import React, { useState } from 'react';
import { FaStar } from 'react-icons/fa';

// Pass `show`, `onClose`, and `onSubmit` as props
const ReviewModal = ({ show, onClose, onSubmit }) => {
    // You can manage form data and hover state internally
    const [formData, setFormData] = useState({ title: '', content: '', rating: 0 });
    const [hover, setHover] = useState(null);
    const [user, setUser] = useState(()=>{
        const storedUser = localStorage.getItem("currentUser");
        if(storedUser){
            return JSON.parse(storedUser)
        }
        else{
            return null
        }
    })

    if (!show) {
        return null; // Don't render anything if the modal is not shown
    }

    const handleReviewChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleRating = (ratingValue) => {
        setFormData(prev => ({ ...prev, rating: ratingValue }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData); // Pass the form data up to the parent
        onClose(); // Close the modal after submission
    };

    const createReview = async (e) => {
        e.preventDefault();
        formData.userId = user.id;
        formData.username = user.username;
        console.log("Submitting review:", formData);


        const response = await axiosInstance.post('/reviews', formData, {
            headers: { "Content-Type": "application/json" }
        });

        if (response.data) {
            console.log('Review added..!');
        }
        else {
            console.log('Error adding review ..!');
        }

        // Reset form
        setFormData({
            title: "",
            content: "",
            rating: 0,
        });
        setHover(null);
        onClose()
        setRating(0);
    };
    return (
        <div className="review-backdrop">
            <div className="review-modal">
                <h5 className="mb-3">Write a Review</h5>
                <form onSubmit={createReview}>
                    <div className="mb-3">
                        <label htmlFor="title" className="form-label">Review title</label>
                        <input
                            className="form-control"
                            id="title"
                            name="title"
                            placeholder="Review title..."
                            value={formData.title}
                            onChange={handleReviewChange}
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="content" className="form-label">Your Review</label>
                        <textarea
                            className="form-control"
                            id="content"
                            name="content"
                            rows="3"
                            placeholder="Share your thoughts..."
                            value={formData.content}
                            onChange={handleReviewChange}
                        />
                    </div>

                    <div className="star-review mb-3">
                        <h6>Rate your experience:</h6>
                        <div className="stars d-flex gap-1">
                            {[...Array(5)].map((_, index) => {
                                const ratingValue = index + 1;
                                return (
                                    <label key={ratingValue}>
                                        <input
                                            type="radio"
                                            name="rating"
                                            value={ratingValue}
                                            onClick={() => handleRating(ratingValue)}
                                            hidden
                                        />
                                        <FaStar
                                            className="star"
                                            color={ratingValue <= (hover || formData.rating) ? '#ffc107' : '#e4e5e9'}
                                            size={32}
                                            onMouseEnter={() => setHover(ratingValue)}
                                            onMouseLeave={() => setHover(null)}
                                        />
                                    </label>
                                );
                            })}
                        </div>
                    </div>

                    {!user && <span className='text-primary'>Login required !</span>}
                    <div className="d-flex justify-content-end">
                        {user ? (<button type="submit" className="btn btn-primary btn-sm me-2" onClick={createReview}>Submit</button>) : <button type="submit" className="btn btn-primary btn-sm me-2" disabled>Submit</button>}
                        <button type="button" className="btn btn-secondary btn-sm" onClick={() => onClose()}>Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ReviewModal;